<template>


    <pre class="TQ_inline">{{co_displayText_s}}<div
            class="TQ_textColor_red TQ_text_bold TQ_inline TQ_clickable"
            v-if="co_showBtn_b"
            @click="displayAllText_b=true">+{{ass_strings.oneWord_More[ps_langCode_e]}}</div></pre>


</template>

<script>
    import {validator_enum_fb} from "../../../functions/src/shareCode/Share_S_Validator";
    import {enum_langCodes} from "../../../functions/src/shareCode/Share_S_Enum";
    import {ass_strings} from "../../../functions/src/shareCode/Share_Ass_Dictionary";

    export default {
        name: "TqLongText",
        props:{
            pb_maxLength_n : {
                type: Number,
                require : 0
            },
            pb_text_s : {
                type: String,
                require : true
            },
            ps_langCode_e:{
                type: String,
                require:true,
                validator(val){
                    return validator_enum_fb(enum_langCodes, val)
                }
            },
        },
        computed:{
            co_showBtn_b(){
                return this.pb_text_s.length > this.pb_maxLength_n && !this.displayAllText_b
            },
            co_displayText_s(){

                return this.co_showBtn_b ? this.pb_text_s.substring(0, this.pb_maxLength_n) +'... ' : this.pb_text_s
            }
        },
        data(){
            return {
                displayAllText_b    : false,
                ass_strings         : ass_strings
            }
        },
    }
</script>

<style scoped>

</style>